import { type Registry as Services, service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type { LookerDashboard, LookerLook } from 'lumen/models';

export default class LookerScheduledPlan extends Model {
  [Type] = 'looker-scheduled-plan' as const;

  @belongsTo('looker-dashboard', { async: true, inverse: null })
  declare dashboard: LookerDashboard;

  @belongsTo('looker-look', { async: true, inverse: null })
  declare look: LookerLook;

  @attr('string') declare crontab: string;
  @attr('dayjs') declare lastRunAt: DayjsTransformReturn;
  @attr('string') declare name: string;
  @attr declare recipients: string[];

  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDashboard() {
    // @ts-expect-error: Argument of type '"dashboard"' is not assignable to parameter of type ...
    return this.belongsTo('dashboard').id();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get type() {
    return this.intl.t(
      this.isDashboard ? 'custom_reporting.dashboard' : 'custom_reporting.look',
    );
  }
}
